import axios from "axios";

const API_URL = "/api/v1/budget";

export const BudgetService = {
    uploadItemPdf: (key, file) => {
        const form = new FormData(); form.append("file", file);
        return axios.post(`${API_URL}/files/items/${key}`, form);
    },
    uploadSubcategoryPdfs: (key, files) => {
        const form = new FormData(); Array.from(files).forEach(file => form.append("files", file));
        return axios.post(`${API_URL}/files/subcategories/${key}`, form);
    },
    getSubcategoryFiles: key => axios.get(`${API_URL}/files/subcategories/${key}`),
    downloadItemPdf: key => axios.get(`${API_URL}/files/items/${key}`, { responseType: "blob" }),
    downloadSubcategoryPdf: (key, objectKey) => axios.get(`${API_URL}/files/subcategories/${key}/${encodeURIComponent(objectKey)}`, { responseType: "blob" }),
    getCategorySettings: () => axios.get(`${API_URL}/settings/categories`),
    createCategory: (kind, data) => axios.post(`${API_URL}/settings/categories/${kind}`, data),
    updateCategory: (kind, key, data) => axios.put(`${API_URL}/settings/categories/${kind}/${key}`, data),
    deleteCategory: (kind, key) => axios.delete(`${API_URL}/settings/categories/${kind}/${key}`),
    getCategories: () => axios.get(`${API_URL}/categories`),
    // =========================================================
    // 1. บริหารจัดการรอบงบประมาณ (Budget Cycles / Rounds)
    // =========================================================
    // ดึงรอบที่กำลังเปิดรับอยู่ในปัจจุบัน
    getActiveRound: () => {
        return axios.get(`${API_URL}/cycles/active`);
    },

    // ดึงรอบงบประมาณทั้งหมด (รองรับ filter เฉพาะรอบที่ active)
    getAllRounds: (onlyActive = false) => {
        return axios.get(`${API_URL}/cycles?onlyActive=${onlyActive}`);
    },

    // สร้างรอบงบประมาณใหม่
    createRound: (data) => {
        return axios.post(`${API_URL}/cycles`, data);
    },

    // แก้ไขข้อมูล / ขยายเวลารอบงบประมาณ
    updateRound: (cycleId, data) => {
        return axios.put(`${API_URL}/cycles/${cycleId}`, data);
    },

    toggleRoundStatus: (cycleId, isActive) => {
        return axios.put(`${API_URL}/cycles/${cycleId}/status`, isActive, {
            headers: { "Content-Type": "application/json" }
        });
    },

    // =========================================================
    // 2. กรรมการชุดกลาง (Global Committee Members)
    // =========================================================
    // ดึงรายชื่อกรรมการชุดกลางทั้งหมด
    getCommittees: () => {
        return axios.get(`${API_URL}/committees`);
    },

    // แต่งตั้งกรรมการเข้าชุดกลาง
    addCommittee: (data) => {
        return axios.post(`${API_URL}/committees`, data);
    },

    // เปิด/ปิด สถานะสิทธิ์การพิจารณารายบุคคล
    toggleCommitteeStatus: (committeeKey, isActive) => {
        return axios.put(`${API_URL}/committees/${committeeKey}/status`, isActive, {
            headers: { "Content-Type": "application/json" }
        });
    },

    // ลบกรรมการออกจากชุดกลาง
    deleteCommittee: (committeeKey) => {
        return axios.delete(`${API_URL}/committees/${committeeKey}`);
    },

    // =========================================================
    // 3. ใบคำขอ & สายอนุมัติ Tier 1 (Department Hierarchical)
    // =========================================================
    // ดึงรายการคำขอสำหรับ Dashboard ตามสิทธิ์ผู้ใช้ (รองรับทั้งผู้สร้างและหัวหน้า)
    getDashboardRequests: (cycleId) => {
        return axios.get(`${API_URL}/cycles/${cycleId}/dashboard-requests`);
    },
    // ดึงแผนคำขอของหน่วยงานในรอบนั้นๆ
    getDepartmentBudget: (cycleId, departmentId) => {
        return axios.get(`${API_URL}/cycles/${cycleId}/departments/${departmentId}/items`);
    },

    // บันทึกคำขอ (Header + โครงการครุภัณฑ์ + รายการ Flat Items)
    saveBudgetRequest: (data) => {
        return axios.post(`${API_URL}/requests/save`, data);
    },

    // ส่งคำขอเข้าสู่สายการอนุมัติ (Trigger State Machine & Step Skipping)
    submitBudgetPlan: (requestKey) => {
        return axios.post(`${API_URL}/approvals/submit`, requestKey, {
            headers: { "Content-Type": "application/json" }
        });
    },
    
    // หัวหน้างาน / หัวหน้ากลุ่มงาน / รองภารกิจ พิจารณาอนุมัติหรือตีกลับ
    actionDepartmentApproval: (data) => {
        return axios.post(`${API_URL}/approvals/department-action`, data);
    },

    // =========================================================
    // 4. การพิจารณาของกรรมการ Tier 2 (Committee Evaluation)
    // =========================================================
    // ดึงรายการที่ผ่านรองภารกิจเพื่อเข้าสู่วาระพิจารณาของกรรมการ
    getCommitteeReviews: (cycleId) => {
        return axios.get(`${API_URL}/cycles/${cycleId}/committee-reviews`);
    },

    // กรรมการบันทึกผลการปรับราคา/จำนวน/มติอนุมัติแบบ Batch
    saveCommitteeBatch: (cycleId, items) => {
        return axios.put(`${API_URL}/cycles/${cycleId}/committee-reviews/batch-save`, items);
    },

    // =========================================================
    // Aliases / Compatibility (สำหรับรองรับโค้ดเก่าที่ยังไม่ได้เปลี่ยนชื่อ)
    // =========================================================
    submitRequest: (data) => {
        return axios.post(`${API_URL}/requests/save`, data);
    },
    approveItem: (data) => {
        return axios.post(`${API_URL}/approvals/department-action`, data);
    },
    updateItemTargetMonth: (itemKey, targetMonth) => {
        return axios.put(`${API_URL}/items/${itemKey}/target-month`, JSON.stringify(targetMonth), {
            headers: { "Content-Type": "application/json" }
        });
    },
    updateBatchTargetMonth: (items) => {
        return axios.put(`${API_URL}/items/batch-target-month`, items);
    },
    // ดึงข้อมูลคำขอและรายการทั้งหมดด้วย RequestKey โดยตรง
    getRequestById: (requestKey) => {
        return axios.get(`${API_URL}/requests/${requestKey}`);
    },

    
};
